//#region REACT
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
//#endregion

//#region UTILS
import useToken from "../../api/internal_api/useToken";
//#endregion

//#region PAGES
import Dashboard from "../Dashboard/Dashboard";
import Login from "../Login/Login";
import Map from "../Map/Map";
//#endregion

//#region COMPONENTS
import SideBar from "../SideBar/SideBar";
//#endregion

//#region STYLES
import "./App.scss";
//#endregion

//#region IMAGES
import CopyrightImage from "../../images/Global/SynergyByDeloitte.png";
//#endregion

function App() {
  //TRANSLATION INIT
  const { t } = useTranslation();

  const { token, setToken } = useToken();

  if (!token) {
    return <Login setToken={setToken} />;
  }

  const PrivateRoute = ({ children }: any) => {
    return token ? children : <Navigate to="/map" />;
  };

  const isNormalUser = (sessionStorage.getItem('access-type')?.toLocaleLowerCase() ?? "").indexOf(t("userKey")) === -1;

  return (
    <div className="Synergy">
      <PrivateRoute>
        <BrowserRouter>
          <div className="Synergy__menu">
            <SideBar />
          </div>
          <div className="Synergy__canvas">
            <div className="Synergy__canvas-router">
              <Routes>
                <Route path="/" element={isNormalUser && token ? <Dashboard /> : <Navigate to="/map" />} />
                <Route path="/map" element={<Map />} />
              </Routes>
            </div>
            <div className="Synergy__canvas-footer">
              <img src={CopyrightImage} alt="Synergy By Deloitte" />
            </div>
          </div>
        </BrowserRouter>
      </PrivateRoute>
    </div>
  );
}

export default App;
